import { render, staticRenderFns } from "./IntegrationsActivationEmailsList.vue?vue&type=template&id=8d82f296&scoped=true&"
import script from "./IntegrationsActivationEmailsList.vue?vue&type=script&lang=ts&"
export * from "./IntegrationsActivationEmailsList.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationsActivationEmailsList.vue?vue&type=style&index=0&id=8d82f296&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d82f296",
  null
  
)

export default component.exports